import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { PRACTICE } from "@/data/practice";

interface CTABannerProps {
  title?: string;
  description?: string;
  cta?: string;
  to?: string;
}

const CTABanner = ({
  title = "Envie d’avancer à votre rythme ?",
  description = "Je vous accueille au cabinet pour l’arrêt du tabac, la confiance en soi, les phobies ou le deuil. Prenez rendez-vous à Chemilly-sur-Yonne, près d’Auxerre.",
  cta = "Prendre rendez-vous",
  to = "/contact",
}: CTABannerProps) => (
  <section className="relative py-16 px-4 sm:px-6 overflow-hidden">
    <div className="absolute inset-0 gradient-hero" />
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="relative z-10 max-w-3xl mx-auto text-center"
    >
      <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4 text-primary-foreground">{title}</h2>
      <p className="font-body text-primary-foreground/80 mb-8 text-lg">{description}</p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
        <Link
          to={to}
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent text-accent-foreground font-body font-semibold text-base hover:brightness-105 transition-all"
        >
          {cta}
          <ArrowRight size={18} />
        </Link>
        <a
          href="tel:+33628436977"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-primary-foreground/30 text-primary-foreground font-body font-semibold text-base hover:bg-primary-foreground/10 transition-all"
        >
          <Phone size={18} /> 06 28 43 69 77
        </a>
      </div>
      <p className="font-body text-primary-foreground/80 text-sm mb-2">{PRACTICE.sessionPriceLabel} · Au cabinet, sur rendez-vous</p>
      <p className="font-body text-primary-foreground/80 text-sm">{PRACTICE.hoursLabel}</p>
    </motion.div>
  </section>
);

export default CTABanner;
